import produce from 'immer'
import { assign } from 'lodash'

import {
  FETCH_CHALLENGE,
  SET_CHALLENGE_PAGE_TO_DIRTY,
  UPDATE_CHALLENGE_IMAGE_DETAILS,
  UPDATE_CHALLENGE_RELATIONS_DETAILS,
  UPDATE_CHALLENGE_SIMPLE_DETAILS,
} from '../action-types'
import { CHALLENGE_INITIAL_STATE } from '../initial-states'

const challengeReducer = (state = CHALLENGE_INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_CHALLENGE_PAGE_TO_DIRTY:
      return produce(state, nextState => assign(nextState, action.payload))
    case FETCH_CHALLENGE.START:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: true,
          fetchError: undefined,
          data: [],
        }),
      )

    case FETCH_CHALLENGE.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: false,
          fetchError: undefined,
          data: action.payload.data.challenge,
        }),
      )

    case FETCH_CHALLENGE.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: false,
          fetchError: action.error.message,
          data: [],
        }),
      )

    case FETCH_CHALLENGE.CLEANUP:
      return { ...CHALLENGE_INITIAL_STATE }

    case UPDATE_CHALLENGE_SIMPLE_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: true,
          simpleDetailsError: undefined,
        }),
      )

    case UPDATE_CHALLENGE_SIMPLE_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: false,
          simpleDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateChallengeSimpleDetails,
          ),
          isDirty: false,
        }),
      )

    case UPDATE_CHALLENGE_SIMPLE_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: false,
          simpleDetailsError: action.error.message,
        }),
      )

    case UPDATE_CHALLENGE_IMAGE_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: true,
          imageDetailsError: undefined,
        }),
      )

    case UPDATE_CHALLENGE_IMAGE_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: false,
          imageDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateChallengeImageDetails,
          ),
        }),
      )

    case UPDATE_CHALLENGE_IMAGE_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: false,
          imageDetailsError: action.error.message,
        }),
      )

    case UPDATE_CHALLENGE_RELATIONS_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isRelationsDetailsLoading: true,
          relationsDetailsError: undefined,
        }),
      )

    case UPDATE_CHALLENGE_RELATIONS_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isRelationsDetailsLoading: false,
          relationsDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateChallengeRelationsDetails,
          ),
        }),
      )

    case UPDATE_CHALLENGE_RELATIONS_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isRelationsDetailsLoading: false,
          relationsDetailsError: action.error.message,
        }),
      )

    default:
      return state
  }
}

export default challengeReducer
